import React from "react";
import localization from "../../../config/localization";
import Drawer from "@material-ui/core/Drawer/Drawer";
import IconButton from "@material-ui/core/IconButton";
import Close from "@material-ui/icons/Close";
import AccountBox from "@material-ui/icons/AccountBox";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Work from "@material-ui/icons/Work";
import Visibility from "@material-ui/icons/Visibility";
import VpnKey from "@material-ui/icons/VpnKey";
import Chat from "@material-ui/icons/Chat";
import ExitToApp from "@material-ui/icons/ExitToApp";
import Hidden from "@material-ui/core/Hidden";
import {
    setPageTitle,
    homePathGenerator,
    getStoredUser,
    slugify
} from "../../../api-client/core/authentication/utils";
import "./TalentProfile.css";
import withStyles from "@material-ui/core/styles/withStyles";
import TalentInfo from "./TalentInfo";
import TalentTags  from "./TalentTags";
import TalentContents from "./TalentContents";
import {Link, Redirect, Route, Router, Switch} from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import {isNull} from "util";
import UpgradeModal from "./UpgradeModal";
import BloomcloudsToggleSwitch from "../../../components/Letflow/BloomcloudsToggleSwitch";
import ContentCreationForm from './TalentContents/ContentCreationForm';
import { request } from "../../../api-client";
import FreshChat from "../../../utils/FreshChat";
import SecurityModal from "./SecurityModal";
import GlobalSnackbar, { GlobalSnackbarTypes } from "../../../components/Letflow/Snackbar/GlobalSnackbar";
import { ArrowBack, EditOutlined, Share, ShareOutlined } from "@material-ui/icons";
import ShareOnSocials from "../../../components/Letflow/ShareOnSocials";
import ProfileUrlModal from "./ProfileUrlModal";
import Safari14Modal from "./Safari14Modal";

const styles = theme => ({
  navIconHide: {
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  }
});

class TalentProfile extends React.Component {
  constructor(props) {
    super(props);
    let currentUser = getStoredUser();
    let isPro = currentUser.activeSubscription && currentUser.activeSubscription.plan && currentUser.activeSubscription.plan.level > 1;
    let isSafari14 = navigator.userAgent.includes("Safari") && navigator.userAgent.includes("Version/14.0");
    this.state = {
      mobileOpen: false,
      openUpgradeModal: false,
      openSecurityModal: false,
      openProfileUrlModal: false,
      role: isPro ? {name: 'Bloom Pro Plan', canUpgrade: false} : {name: 'Bloom Basic Plan', canUpgrade: true},
      visibility: currentUser.contentCreator ? currentUser.contentCreator.active : true,
      showShareDialog: false,
      openSafariModal: isSafari14
    };
  }

  componentDidMount = () => {
    setPageTitle(localization.get("title.talent_profile"));
    document.getElementsByTagName("html")[0].scrollTop = 0;
  };

  handleDrawerToggle = () => {
    this.setState(state => ({ mobileOpen: !state.mobileOpen }));
  };

  isSelected = route => route && window.location.pathname.includes(route);

  renderUpgradeModal = () => {
    return this.state.openUpgradeModal && 
      <UpgradeModal 
        onModalEnd={() => this.setState({openUpgradeModal: false, role: {name: 'Bloom Pro Plan', canUpgrade: false}})}
        onClose={() => this.setState({openUpgradeModal: false})} 
        open={this.state.openUpgradeModal}
      />
  }

  renderSafari14Modal = () => {
    return this.state.openSafariModal && 
      <Safari14Modal 
        onClose={() => this.setState({openSafariModal: false})}
        open={this.state.openSafariModal}
      />
  }

  renderSecurityModal = () => {
    return this.state.openSecurityModal && 
      <SecurityModal 
        onClose={() => this.setState({openSecurityModal: false})}
        open={this.state.openSecurityModal}
      />
  }

  renderProfileUrlModal = () => {
    return this.state.openProfileUrlModal && 
      <ProfileUrlModal 
        onClose={() => this.setState({openProfileUrlModal: false})}
        open={this.state.openProfileUrlModal}
      />
  }

  openUpgradeBanner = () => {
    this.setState({openUpgradeModal: true});
  }

  handleVisibilityChange = (visibility) => {
    let currentUser = getStoredUser();
    if (!currentUser.contentCreator){
      return;
    }
    if (visibility) {
      let creator = currentUser.contentCreator;
      var span = document.createElement('span');
      span.innerHTML = creator.description;
      let description = span.textContent || span.innerText;
      if (!creator.image || !(description && description.length > 0)) {
        GlobalSnackbar.show({message: localization.get("talent_profile.visibility_check"), type: GlobalSnackbarTypes.ERROR});
        return;
      }
    }
    request.contentCreator.update({id: currentUser.contentCreator.id, active: visibility ? 1 : 0}).then(response => this.setState({visibility: response.active}, () => request.authentication.getUser())); 
  }

  renderShareDialog = () => {
    let profileUrl = this.getPublicProfileUrl();
    if (!profileUrl) return;
    return (
      <ShareOnSocials
        show={this.state.showShareDialog}
        handleClose={() => this.setState({showShareDialog: false})}
        url={`${window.location.protocol}//${window.location.hostname}${profileUrl}`}
        darkMode={true}
        title={localization.get("share_profile")}
        hideReceiver={true}
      />
    )
  };

  getProfileUrl() {
    let currentUser = getStoredUser();
    if (!currentUser.contentCreator) {
      return null;
    }
    let contentCreator = currentUser.contentCreator;
    if (!contentCreator) {
      return null;
    }
    return homePathGenerator(`contenido/${contentCreator.id}-${slugify(contentCreator.name)}`);
  }

  getPublicProfileUrl() {
    let currentUser = getStoredUser();
    if (!currentUser.contentCreator) {
      return null;
    }
    let contentCreator = currentUser.contentCreator;
    if (!contentCreator) {
      return null;
    }
    return contentCreator.profile_url ? `/bl/${contentCreator.profile_url}` : homePathGenerator(`contenido/${contentCreator.id}-${slugify(contentCreator.name)}`);
  }

  render = () => {
    const { classes } = this.props;
    const currentUser = getStoredUser();

    const sidebar = (() => {
      const makeSidebarLink = (isSelectedLabel, Logo, to, label, disabled, tooltip=localization.get("talent_profile.not_available")) =>
        (
          <Link
            onClick={e => {
              if (isNull(to) || disabled || this.isSelected(isSelectedLabel)) {
                e.preventDefault();
              } else {
                this.handleDrawerToggle();
              }
            }}
            to={to || "#"}
          >
            <div
              className={`talent-profile-link-container ${
                this.isSelected(isSelectedLabel) ? "selected" : ""
              }`}
            >
              <div className="talent-profile-link-logo">
                <Logo style={{ fontSize: "14px" }} />
              </div>
              {(() => {
                const content = (
                  <div className="talent-profile-link">{label}</div>
                );
                if (disabled) {
                  return (
                    <Tooltip
                      title={tooltip}
                      placement="right"
                    >
                      {content}
                    </Tooltip>
                  );
                }
                if (isNull(to)) {
                  return (
                    <Tooltip
                      title={localization.get("sidebar.soon")}
                      placement="right"
                    >
                      {content}
                    </Tooltip>
                  );
                }
                return content;
              })()}
            </div>
          </Link>
        );
      const makeSidebarLinkWithCallback = (Logo, onClick, label, disabled=false, tooltip=localization.get("talent_profile.not_available")) => 
        (
          <a onClick={disabled ? null : onClick}>
            <div className="talent-profile-link-container">
              <div className="talent-profile-link-logo">
                <Logo style={{ fontSize: "14px" }} />
              </div>
              {(() => {
                const content = (
                  <div className="talent-profile-link">{label}</div>
                );
                if (disabled) {
                  return (
                    <Tooltip
                      title={tooltip}
                      placement="right"
                    >
                      {content}
                    </Tooltip>
                  );
                }
                if (isNull(onClick)) {
                  return (
                    <Tooltip
                      title={localization.get("sidebar.soon")}
                      placement="right"
                    >
                      {content}
                    </Tooltip>
                  );
                }
                return content;
              })()}
            </div>
          </a>
        );
    
        return (
          <div className="talent-profile-drawer-container">
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={this.handleDrawerToggle}
              className={classes.navIconHide}
              style={{
                position: "absolute",
                right: "20px",
                top: "15px",
                zIndex: "1000"
              }}
            >
              <Close />
            </IconButton>
            <div className="talent-profile-avatar-container" style={currentUser.contentCreator && currentUser.contentCreator.image && {backgroundImage: `url(${request.file.image.makeCroppedUrl(currentUser.contentCreator.image.id, 200, 200)})`}}></div>

            <div className="talent-profile-user-info-container">
              <div className="talent-profile-name">{currentUser.contentCreator ? currentUser.contentCreator.name : currentUser.name}</div>
              {
                this.state.role.canUpgrade ?
                  <div className="talent-profile-label" style={{display: 'block'}}>{`${this.state.role.name} | `}<a style={{cursor: 'pointer'}} onClick={() => this.openUpgradeBanner()}>Upgrade</a></div>
                :
                <div className="talent-profile-label">{this.state.role.name}</div>
              }
              <div style={{marginTop: '15px'}}>
                <BloomcloudsToggleSwitch
                  id="visible-toggle-switch"
                  Name="visible"
                  Text={[localization.get('form.visible'), localization.get('form.not_visible')]}
                  onChange={(e) => this.handleVisibilityChange(e.target.checked)}
                  currentValue={this.state.visibility}
                  disabled={!currentUser.contentCreator}
                  uncheckedColor="red"
                />
              </div>
            </div>

            <div className="talent-profile-link-set">
              {makeSidebarLink(
                "informacion-general",
                AccountBox,
                homePathGenerator("mi-perfil/informacion-general"),
                localization.get("talent_profile.general_info"),
                false
              )}
              {makeSidebarLink(
                "etiquetas",
                LocalOffer,
                homePathGenerator("mi-perfil/etiquetas"),
                localization.get("talent_profile.tags"),
                !currentUser.contentCreator
              )}
              {makeSidebarLink(
                "contenidos",
                Work,
                homePathGenerator("mi-perfil/contenidos"),
                localization.get("talent_profile.contents"),
                !currentUser.contentCreator
              )}
            </div>
            <div className="talent-profile-link-set">
              <Tooltip
                disableHoverListener={!currentUser.contentCreator}
                title={localization.get("talent_profile.edit_url.tooltip")}
                placement="bottom"
              >
                {makeSidebarLinkWithCallback(
                  EditOutlined,
                  () => this.setState({openProfileUrlModal: true}),
                  localization.get("talent_profile.edit_url"),
                  !currentUser.contentCreator,
                )}
              </Tooltip>
              {makeSidebarLink(
                null,
                Visibility,
                currentUser.contentCreator ? this.getPublicProfileUrl() : null,
                localization.get("talent_profile.profile"),
                !currentUser.contentCreator || !this.state.visibility,
                localization.get(this.state.visibility ? "talent_profile.not_available" : "talent_profile.not_available_invisible") 
              )}
              {makeSidebarLinkWithCallback(
                ShareOutlined,
                () => this.setState({showShareDialog: true}),
                localization.get("talent_profile.share_profile"),
                !currentUser.contentCreator || !this.state.visibility,
                localization.get(this.state.visibility ? "talent_profile.not_available" : "talent_profile.not_available_invisible") 
              )}
              {makeSidebarLinkWithCallback(
                VpnKey,
                () => this.setState({openSecurityModal: true}),
                localization.get("talent_profile.security")
              )}
              {makeSidebarLinkWithCallback(
                Chat,
                () => FreshChat.open(),
                localization.get("talent_profile.support")
              )}
              {makeSidebarLinkWithCallback(
                ExitToApp,
                () => request.authentication.logout(),
                localization.get("talent_profile.sign_out")
              )}
            </div>
          </div>
        );
      })();
    
    let makeNavbarLink = (isSelectedLabel, Logo, to, label, disabled) => (
      <Link
        onClick={e => {
          if (isNull(to) || disabled || this.isSelected(isSelectedLabel)) {
            e.preventDefault();
          }
        }}
        to={to || "#"}
      >
        <div
          className={`talent-profile-link-container ${
            this.isSelected(isSelectedLabel) ? "selected" : ""
          }`}
        >
          <div className="talent-profile-link-logo">
            <Logo style={{ fontSize: "24px" }} />
          </div>
          {(() => {
            const content = (
              <div className="talent-profile-link">{label}</div>
            );
            if (disabled) {
              return (
                <Tooltip
                  title={localization.get("talent_profile.not_available")}
                  placement="bottom"
                >
                  {content}
                </Tooltip>
              );
            }
            if (isNull(to)) {
              return (
                <Tooltip
                  title={localization.get("sidebar.soon")}
                  placement="bottom"
                >
                  {content}
                </Tooltip>
              );
            }
            return content;
          })()}
        </div>
      </Link>
    );
    return (
      <>
      {this.renderShareDialog()}
      <div className="profile-navbar">
        <div className="profile-navbar-left">
          <Link to={homePathGenerator(``)}>
            <IconButton
              color="black"
            >
              <ArrowBack/>
            </IconButton>
          </Link>
          <div className="talent-profile-avatar-container" style={currentUser.contentCreator && currentUser.contentCreator.image && {backgroundImage: `url(${request.file.image.makeCroppedUrl(currentUser.contentCreator.image.id, 50, 50)})`}}></div>
        </div>
        <div className="profile-navbar-right">
          <BloomcloudsToggleSwitch
            id="visible-toggle-switch"
            Name="visible"
            Text={[localization.get('form.visible'), localization.get('form.not_visible')]}
            onChange={(e) => this.handleVisibilityChange(e.target.checked)}
            currentValue={this.state.visibility}
            disabled={!currentUser.contentCreator}
            uncheckedColor="red"
          />
          <IconButton
            color="black"
            style={{width: '30px'}}
            onClick={() => {
              if (!currentUser.contentCreator || !this.state.visibility) {
                return;
              }
              this.setState({showShareDialog: true});
            }}
          >
            <Share/>
          </IconButton>
          {/* TODO: set right FAQs url when enabled*/}
          {/* <Link to={homePathGenerator(`faqs`)}>
            <IconButton
              color="black"
              style={{width: '30px'}}
            >
              <Help/>
            </IconButton>
          </Link> */}
        </div>
      </div>
      <div className="profile-secondary-navbar">
        {makeNavbarLink(
          "informacion-general",
          AccountBox,
          homePathGenerator("mi-perfil/informacion-general"),
          localization.get("talent_profile.general_info"),
          false
        )}
        {makeNavbarLink(
          "etiquetas",
          LocalOffer,
          homePathGenerator("mi-perfil/etiquetas"),
          localization.get("talent_profile.tags"),
          !currentUser.contentCreator
        )}
        {makeNavbarLink(
          "contenidos",
          Work,
          homePathGenerator("mi-perfil/contenidos"),
          localization.get("talent_profile.contents"),
          !currentUser.contentCreator
        )}
      </div>
      <div id="innerinner" className="home-playlists talent-profile-innerinner" style={{paddingTop: '20px', backgroundColor: 'rgb(247,247,247)'}}>
        {this.renderUpgradeModal()}
        {this.renderSecurityModal()}
        {this.renderProfileUrlModal()}
        {this.renderSafari14Modal()}
        {/* <IconButton
          color="inherit"
          aria-label="Open drawer"
          onClick={this.handleDrawerToggle}
          className={classes.navIconHide}
          style={{
              zIndex:100
          }}
        >
          <MenuIcon />
        </IconButton> */}
  
        <Hidden mdUp>
          <Drawer
            variant="temporary"
            anchor={"left"}
            open={this.state.mobileOpen}
            onClose={this.handleDrawerToggle}
            ModalProps={{
            keepMounted: true // Better open performance on mobile.
            }}
          >
            {sidebar}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            variant="permanent"
            open
            containerStyle={{
              height: '100%'
            }}
            PaperProps={{
              style: {
                float: "left",
                width: "250px",
                boxShadow: "0 1px 10px 0 rgba(0,0,0,.1)",
                borderRight: "none",
                backgroundColor: "white",
                zIndex: "0",
                minHeight: "100vh",
                marginTop: "70px"
              }
            }}
          >   
            {sidebar}
          </Drawer>
        </Hidden>
        <div className="talent-profile-content">
          <Router {...this.props}>
            <Switch>
              <Route
                exact
                path="/mi-perfil"
                component={() => <Redirect to="/mi-perfil/informacion-general"/>}
              />
              <Route path="/mi-perfil/informacion-general">
                <TalentInfo></TalentInfo>
              </Route>
              <Route path="/mi-perfil/etiquetas">
                {!currentUser.contentCreator ? <Redirect to="informacion-general"/> : <TalentTags></TalentTags>}
              </Route>
              <Route path="/mi-perfil/contenidos/nuevo">
                {!currentUser.contentCreator ? <Redirect to="informacion-general"/> : <ContentCreationForm></ContentCreationForm>}
              </Route>
              <Route
                path="/mi-perfil/contenidos/:contentCreationId/editar">
                {!currentUser.contentCreator ? <Redirect to="informacion-general"/> : <ContentCreationForm></ContentCreationForm>}
              </Route>
              <Route path="/mi-perfil/contenidos">
                {!currentUser.contentCreator ? <Redirect to="informacion-general"/> : <TalentContents></TalentContents>}
              </Route>
            </Switch>
          </Router>
        </div>
      </div>
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(TalentProfile);